import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Link, useNavigate } from 'react-router-dom';
import classnames from 'classnames';
import RideDetails from 'components/RideDetails/RideDetails';
import Layout from 'components/Layout/Layout';
import Switch from 'components/Switch/Switch';
import Button from 'components/Button/Button';
import Map from 'components/Map/Map';
import ParkScooter from 'components/ParkScooter/ParkScooter';
import RidesStore from 'stores/Rides';
import styles from './Ride.module.scss';
import UserStore from 'stores/User';
import ZonesStore from 'stores/Zones';
import Spinner from 'components/Spinner/Spinner';

const UPDATE_INTERVAL = 10 * 1000;

const Ride = observer(() => {
  const navigate = useNavigate();
  const ride = RidesStore.show(RidesStore.active);
  const [ parkScooterPopupVisible, setParkScooterPopupVisible ] =  useState(false);

  useEffect(() => {
    RidesStore.fetch();

    const timer = setInterval(() => {
      RidesStore.fetch();
    }, UPDATE_INTERVAL);

    if (ride) {
      ZonesStore.fetchParkingZones(ride?.scooterId);
    }

    return () => {
      clearInterval(timer);
    };
  }, []);

  // useEffect(() => {
  //   if (ride?.tracks?.length) {
  //     console.log('RidesStore.active', RidesStore.active);
  //     // ZonesStore.fetchParkingZones(latitude, longitude)
  //   }
  // }, [ ride?.tracks ]);

  useEffect(() => {
    if (RidesStore.list.length === 0) {
      navigate('/');
    }
  }, [ RidesStore.list ]);

  function onTurboStatusChange(command) {
    ride?.toggleTurboMode(command);
  }

  function complete() {
    setParkScooterPopupVisible(true);
  }

  function onPark() {
    setParkScooterPopupVisible(false);
    RidesStore.complete(ride?.id);
  }

  function getCenter() {
    const { latitude = 0, longitude = 0 } = ride?.tracks?.[ride?.tracks?.length - 1] ?? {};
    return {
      lat: latitude,
      lng: longitude
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.map}>
        <Map 
          tracks={ride?.tracks} 
          center={getCenter()}
        />
      </div>
      <div className={styles.body}>
        <div className={styles.list}>
          {RidesStore.list?.map(id =>
            <div 
              onClick={event => RidesStore.select(id)}
              className={classnames(styles.item, {
                [styles.active]: id === RidesStore.active
              })}
              key={id}
            >
              #{RidesStore.show(id)?.scooterId}
            </div>
          )}
          <Link 
            to="/ride/create"
            className={classnames(styles.item)}
          >
            Add a Scooter
          </Link>
        </div>

        <Layout>
          {!!ride?.turboStatus && 
            <div className={styles.turbo}>
              <div className={styles.label}>
                Acceleration
              </div>
              <Switch 
                turboStatus={ride.turboStatus} 
                onChange={onTurboStatusChange}
              />
            </div>
          }

          {!UserStore.subscribed &&
            <RideDetails ride={ride} />
          }

          <div className={styles.footer}>
            {ride?.completing ?
              <Spinner />
            :
              <Button onClick={complete}>
                End Ride
              </Button>
            }
          </div>
        </Layout>
      </div>

      <ParkScooter 
        visible={parkScooterPopupVisible} 
        onContinue={event => setParkScooterPopupVisible(false)}
        onPark={onPark}
      />
    </div>
  );
});

export default Ride;
